import { getMyBookings } from '@api/booking';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BookingsState } from '@utils/types';

export const getBookings = createAsyncThunk('getBookings', async () => {
  const bookings = await getMyBookings();
  return bookings;
});

const initialState: BookingsState = {
  bookings: {
    pastBookings: [],
    upcomingBookings: [],
    todaysBookings: [],
  },
};

export const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBookings.fulfilled, (state, action) => {
      state.bookings = action.payload;
    });
  },
});

// Action creators are generated for each case reducer function
// export const {} = bookingSlice.actions;

export default bookingSlice.reducer;
